<script setup lang="ts">
// Logo mark + "VirtualTourEasy" wordmark, as on virtualtoureasy.com.
withDefaults(defineProps<{ size?: number; wordmark?: boolean; tone?: 'dark' | 'light' }>(), {
  size: 30,
  wordmark: true,
  tone: 'dark',
})
</script>

<template>
  <span class="inline-flex items-center gap-2.5 select-none">
    <span class="vte-mark shrink-0" :style="{ width: `${size}px`, height: `${Math.round(size * 0.733)}px` }" aria-hidden="true" />
    <span
      v-if="wordmark"
      class="text-[17px] font-bold tracking-[-0.02em] leading-none whitespace-nowrap"
      :class="tone === 'light' ? 'text-white' : 'text-slate-900'"
    >VirtualTour<span :class="tone === 'light' ? 'text-blue-300' : 'text-blue-600'">Easy</span></span>
  </span>
</template>
